<template>
    <div>
        <div class="md-dialog md-theme-default certificate-dialog-container">
            <div class="dialog-title-container">
                <div style="display: flex; flex-grow: 1;"><h4 class="text-primary"><b>{{translate(locale.certificate_setting)}}</b></h4></div>
                <div @click="close_preview()" style="cursor: pointer;"><i class="material-icons button-icon">cancel</i></div>
            </div>
            <div class="dialog-content-container">
                <div class="md-layout">
                    <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-40 md-size-40" style="height: 100%; overflow-y: scroll;">
                        <div class="md-layout">
                            <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" v-for="(cert, index) in certificate_data" v-if="index > 4">
                                <form-input v-model="certificate_data[index].value" :label="certificate_data[index].name" type="text"/>
                            </div>
                            <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
                                <md-button class="md-raised md-primary action-button" @click="update_certificate()" :disabled="generating"><i class="material-icons button-icon">check_circle</i> {{translate(locale.edit_update)}}</md-button>
                            </div>
                        </div>
                    </div>
                    <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-60 md-size-60">
                        <loading v-if="generating" />
                        <h4 class="text-primary text-center" v-if="!generating && certificate == null">{{translate(locale.please_create_certificate)}}</h4>
                        <iframe :src="config.verify_base_url + certificate" class="certificate-iframe" v-if="!generating && certificate != null"></iframe>
                    </div>   
                </div>
            </div>  
        </div>
        <transition name="fade" mode="out-in">
            <div class="md-overlay md-fixed md-dialog-overlay" @click="close_preview()"></div>
        </transition>
    </div>
</template>
<script>
    export default {
        props: {
            certificate_data: {
                type: Array
            },
            certificate: {
                type: String
            }
        },
        data() {
            return {
                generating: false
            }
        },
        methods: {
            update_certificate() {
                this.generating = true;
                this.$http.post(this.config.api + "/user/application/update_certificate", {
					hash: this.$route.params.hash,
                    certificate_data: this.certificate_data
				}).then(res => {
					if (res.body.status == 'success') {
                        setTimeout(() => {
                            this.generating = false;
                            this.$emit("update");
                        }, 2000)
					}
				}) 
            },
            close_preview() {
                this.$emit('close');
            }
        }
    }
</script>

<style scoped>
    .certificate-dialog-container {
        width: 95%;
        max-width: 95%;
        min-width: 95%;
        height: 95%;
        max-height: 95%;
        min-height: 95%;
        padding: 5px 15px 15px 15px;
        border-radius: 6px;
        z-index: 100;
        display: flex; 
        flex-direction: column; 
    }
    .dialog-title-container {
        display: flex; 
        flex-direction: row; 
        align-items: center;
    }
    .dialog-content-container {
        display: flex; 
        flex-grow: 1; 
        height: 0;
    }

    .certificate-iframe {
        width: 100%; 
        height: 100%; 
        min-height: 450px;
        border: 0; 
        border-radius: 6px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Certificate.vue